import { createTheme } from '@mui/material';

import breakpoints from './breakpoints';
import palette from './palette';
import spacing from './spacing';
import typography from './typography';

const baseTokens = createTheme({
  spacing,
  breakpoints,
  palette,
  typography,
});

export default baseTokens;
